export const ViewFullCenterFlexStyles = {
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  width: '100%',
  height: '100%',
};
